import { BreadCrumbs, SettingsWrapper } from 'BreetComponents';

import type { IPinManagementFormWrapper } from './PinManagement.helpers';

const PinManagementFormWrapper = ({ title, children, isModal }: IPinManagementFormWrapper) => (
	<div className='subbodycontent'>
		<SettingsWrapper isSub>
			{!isModal && (
				<BreadCrumbs
					noHome
					pageTitle={title}
				/>
			)}
			<div className='securityformwrapper border-dark-navy'>{children}</div>
		</SettingsWrapper>
	</div>
);

export default PinManagementFormWrapper;
